<span class="line-through"><slot /></span>
